export const puriData = [{
    "id":"1",
    "name":"Poori",
    "price":"Price :₹45",
    "image": process.env.PUBLIC_URL + "/assests/puri/1.jpg",
    "description": "Fluffy, golden-brown puffed puris served with a classic, flavorful potato masala curry."
}]